/**
 * WhyNotReminderSection
 *
 * Two-column comparison: "The reminder approach" vs "The MomentSent approach".
 * Desktop: side-by-side. Mobile: stacked.
 */

const reminderSteps = [
  { icon: '✓', positive: true,  text: 'You set a reminder for Mom\'s birthday' },
  { icon: '✗', positive: false, text: 'Reminder fires, you\'re in a meeting' },
  { icon: '✗', positive: false, text: 'You remember at 10pm, it\'s too late to mail' },
  { icon: '✗', positive: false, text: 'You text "Happy Birthday!" instead' },
  { icon: '✗', positive: false, text: 'The card never comes. She noticed.' },
];

const momentsSteps = [
  { text: 'You add Mom once, birthday, address, what she loves' },
  { text: '14 days out, we text you to review your card' },
  { text: 'You approve it in 30 seconds from your phone' },
  { text: 'We print, address, stamp, and mail it' },
  { text: 'Mom opens a real card, in her mailbox, from you' },
];

export default function WhyNotReminderSection() {
  return (
    <section className="bg-white py-20">
      <div className="section-container">

        {/* Label + heading */}
        <div className="text-center mb-12">
          <span className="font-body text-xs tracking-widest uppercase text-sage font-semibold mb-3 block">
            The honest comparison
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-navy">
            A reminder tells you to care.<br className="hidden md:block" /> MomentSent shows it.
          </h2>
        </div>

        {/* Two-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-10">

          {/* LEFT: reminder approach */}
          <div className="rounded-card border border-red-100 bg-gray-50 p-6 md:p-8">
            <h3 className="font-heading text-xl text-gray-700 mb-6">
              📱 The reminder approach
            </h3>
            <ol className="space-y-4">
              {reminderSteps.map((step, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span
                    className={[
                      'mt-0.5 flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold',
                      step.positive
                        ? 'bg-green-100 text-green-600'
                        : 'bg-red-100 text-red-500',
                    ].join(' ')}
                  >
                    {step.icon}
                  </span>
                  <span
                    className={[
                      'font-body text-sm leading-relaxed',
                      step.positive ? 'text-gray-700' : 'text-gray-400',
                    ].join(' ')}
                  >
                    {step.text}
                  </span>
                </li>
              ))}
            </ol>
          </div>

          {/* RIGHT: MomentSent approach */}
          <div className="rounded-card border border-sage/30 bg-sage/5 p-6 md:p-8">
            <h3 className="font-heading text-xl text-sage mb-6">
              💌 The MomentSent approach
            </h3>
            <ol className="space-y-4">
              {momentsSteps.map((step, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold bg-sage/20 text-sage">
                    ✓
                  </span>
                  <span className="font-body text-sm text-navy leading-relaxed">
                    {step.text}
                  </span>
                </li>
              ))}
            </ol>
          </div>

        </div>

        {/* Bottom callout pill */}
        <div className="flex justify-center">
          <span className="font-heading text-lg text-white bg-navy rounded-full px-8 py-3 shadow-warm-lg">
            One setup. Zero effort. Every year.
          </span>
        </div>

      </div>
    </section>
  );
}
